import { call, put, SagaReturnType, takeEvery } from 'redux-saga/effects';
import templateService from 'src/services/apiServices/document-management/template-service';
import { documentationActions } from '../../actions/constant';
const {
  REQUEST_DUE_DOCUMENT_SETTING_REQUEST,
  REQUEST_DUE_DOCUMENT_SETTING_SUCCESS,
  REQUEST_DUE_DOCUMENT_SETTING_FAILURE,
  REQUEST_DUE_DOCUMENT_SETTING_RESET,
  REQUEST_DUE_DOCUMENT_SETTING_LOADING,
} = documentationActions;

function* dueDocSettings(action: any): SagaReturnType<any> {
  try {
    yield put({ type: REQUEST_DUE_DOCUMENT_SETTING_LOADING });
    const response = yield call(templateService.getDocDueSettings, action.payload);
    if (response?.status === 200) {
      yield put({ type: REQUEST_DUE_DOCUMENT_SETTING_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: REQUEST_DUE_DOCUMENT_SETTING_FAILURE, payload: error });
  }
}

function* dueDocSettingsSaga() {
  yield takeEvery(REQUEST_DUE_DOCUMENT_SETTING_REQUEST, dueDocSettings);
}

export default dueDocSettingsSaga;
